module.exports = __webpack_public_path__ + "static/media/km.6700f521.svg";